/**
 * /privacy — Oeffentliche Datenschutzerklaerung (F-PUBLIC-LEGAL-1)
 *
 * Art. 13 DSGVO verlangt, dass die Datenschutzerklaerung jederzeit OHNE
 * Login erreichbar ist. Diese Top-Level-Route liegt bewusst ausserhalb des
 * `_auth`-Baums und rendert dieselbe PrivacyPage-Komponente wie die
 * eingeloggte Ansicht unter /legal/privacy — keine inhaltliche Divergenz,
 * nur ein anderer (oeffentlicher) Navigations-Rahmen (PublicLegalLayout).
 */
import { createFileRoute } from '@tanstack/react-router'
import { PublicLegalLayout } from '../features/legal/PublicLegalLayout'
import { PrivacyPage } from '../features/legal/PrivacyPage'

export const Route = createFileRoute('/privacy')({
  component: () => (
    <PublicLegalLayout activeTab="privacy">
      <PrivacyPage />
    </PublicLegalLayout>
  ),
})
